module.exports = __webpack_public_path__ + "img/logo.44612a42.png";